module.exports = __webpack_public_path__ + "static/media/excellent.1ff80612.png";